var map = {
	"./2015": [
		2624,
		9,
		2624
	],
	"./2015.ts": [
		2624,
		9,
		2624
	],
	"./2015/PV.csv": [
		7045,
		1,
		7045
	],
	"./2015/PV_wsch_zach.csv": [
		852,
		1,
		852
	],
	"./2015/srednia_temp.csv": [
		9667,
		1,
		9667
	],
	"./2015/wiatr_lad.csv": [
		617,
		1,
		617
	],
	"./2015/wiatr_lad_6MGW.csv": [
		778,
		1,
		778
	],
	"./2015/wiatr_offshore.csv": [
		6864,
		1,
		6864
	],
	"./2015/zuzycie_pradu.csv": [
		663,
		1,
		663
	],
	"./2016": [
		3211,
		9,
		3211
	],
	"./2016.ts": [
		3211,
		9,
		3211
	],
	"./2016/PV.csv": [
		2396,
		1,
		2396
	],
	"./2016/PV_wsch_zach.csv": [
		8706,
		1,
		8706
	],
	"./2016/srednia_temp.csv": [
		8143,
		1,
		8143
	],
	"./2016/wiatr_lad.csv": [
		9198,
		1,
		9198
	],
	"./2016/wiatr_lad_6MGW.csv": [
		6619,
		1,
		6619
	],
	"./2016/wiatr_offshore.csv": [
		5315,
		1,
		5315
	],
	"./2016/zuzycie_pradu.csv": [
		7569,
		1,
		7569
	],
	"./2017": [
		1749,
		9,
		1749
	],
	"./2017.ts": [
		1749,
		9,
		1749
	],
	"./2017/PV.csv": [
		3519,
		1,
		3519
	],
	"./2017/PV_wsch_zach.csv": [
		4346,
		1,
		4346
	],
	"./2017/srednia_temp.csv": [
		8765,
		1,
		8765
	],
	"./2017/wiatr_lad.csv": [
		2010,
		1,
		2010
	],
	"./2017/wiatr_lad_6MGW.csv": [
		8682,
		1,
		8682
	],
	"./2017/wiatr_offshore.csv": [
		5275,
		1,
		5275
	],
	"./2017/zuzycie_pradu.csv": [
		6279,
		1,
		6279
	],
	"./2018": [
		645,
		9,
		645
	],
	"./2018.ts": [
		645,
		9,
		645
	],
	"./2018/PV.csv": [
		6385,
		1,
		6385
	],
	"./2018/PV_wsch_zach.csv": [
		8291,
		1,
		8291
	],
	"./2018/srednia_temp.csv": [
		7533,
		1,
		7533
	],
	"./2018/wiatr_lad.csv": [
		834,
		1,
		834
	],
	"./2018/wiatr_lad_6MGW.csv": [
		987,
		1,
		987
	],
	"./2018/wiatr_offshore.csv": [
		676,
		1,
		676
	],
	"./2018/zuzycie_pradu.csv": [
		2159,
		1,
		2159
	],
	"./2019": [
		2233,
		9,
		2233
	],
	"./2019.ts": [
		2233,
		9,
		2233
	],
	"./2019/PV.csv": [
		1110,
		1,
		1110
	],
	"./2019/PV_wsch_zach.csv": [
		8904,
		1,
		8904
	],
	"./2019/srednia_temp.csv": [
		3299,
		1,
		3299
	],
	"./2019/wiatr_lad.csv": [
		8584,
		1,
		8584
	],
	"./2019/wiatr_lad_6MGW.csv": [
		1082,
		1,
		1082
	],
	"./2019/wiatr_offshore.csv": [
		8513,
		1,
		4381
	],
	"./2019/zuzycie_pradu.csv": [
		1228,
		1,
		1228
	],
	"./2020": [
		7846,
		9,
		7846
	],
	"./2020.ts": [
		7846,
		9,
		7846
	],
	"./2020/PV.csv": [
		7301,
		1,
		7301
	],
	"./2020/PV_wsch_zach.csv": [
		9475,
		1,
		9475
	],
	"./2020/srednia_temp.csv": [
		4072,
		1,
		4072
	],
	"./2020/wiatr_lad.csv": [
		7960,
		1,
		7960
	],
	"./2020/wiatr_lad_6MGW.csv": [
		6924,
		1,
		6924
	],
	"./2020/wiatr_offshore.csv": [
		4474,
		1,
		4474
	],
	"./2020/zuzycie_pradu.csv": [
		6739,
		1,
		6739
	],
	"./2021": [
		7235,
		9,
		7235
	],
	"./2021.ts": [
		7235,
		9,
		7235
	],
	"./2021/PV.csv": [
		8818,
		1,
		8818
	],
	"./2021/PV_wsch_zach.csv": [
		8708,
		1,
		8708
	],
	"./2021/srednia_temp.csv": [
		9588,
		1,
		9588
	],
	"./2021/wiatr_lad.csv": [
		893,
		1,
		893
	],
	"./2021/wiatr_lad_6MGW.csv": [
		5123,
		1,
		5123
	],
	"./2021/wiatr_offshore.csv": [
		3916,
		1,
		3916
	],
	"./2021/zuzycie_pradu.csv": [
		7416,
		1,
		7416
	],
	"./2022": [
		3774,
		9,
		3774
	],
	"./2022.ts": [
		3774,
		9,
		3774
	],
	"./2022/PV.csv": [
		8896,
		1,
		8896
	],
	"./2022/PV_wsch_zach.csv": [
		1155,
		1,
		1155
	],
	"./2022/srednia_temp.csv": [
		7698,
		1,
		7698
	],
	"./2022/wiatr_lad.csv": [
		5085,
		1,
		5085
	],
	"./2022/wiatr_lad_6MGW.csv": [
		7926,
		1,
		7926
	],
	"./2022/wiatr_offshore.csv": [
		3029,
		1,
		3029
	],
	"./2022/zuzycie_pradu.csv": [
		3013,
		1,
		3013
	],
	"./2023": [
		8843,
		9,
		8843
	],
	"./2023.ts": [
		8843,
		9,
		8843
	],
	"./2023/PV.csv": [
		8097,
		1,
		8097
	],
	"./2023/PV_wsch_zach.csv": [
		1042,
		1,
		1042
	],
	"./2023/srednia_temp.csv": [
		5998,
		1,
		5998
	],
	"./2023/wiatr_lad.csv": [
		6858,
		1,
		6858
	],
	"./2023/wiatr_lad_6MGW.csv": [
		339,
		1,
		339
	],
	"./2023/wiatr_offshore.csv": [
		9533,
		1,
		9533
	],
	"./2023/zuzycie_pradu.csv": [
		4903,
		1,
		4903
	],
	"./2024": [
		3915,
		9,
		3915
	],
	"./2024.ts": [
		3915,
		9,
		3915
	],
	"./2024.zip": [
		8872,
		1,
		8872
	],
	"./2024/PV.csv": [
		2610,
		1,
		2610
	],
	"./2024/PV_wsch_zach.csv": [
		3489,
		1,
		3489
	],
	"./2024/srednia_temp.csv": [
		3218,
		1,
		3218
	],
	"./2024/wiatr_lad.csv": [
		1540,
		1,
		8513
	],
	"./2024/wiatr_lad_6MGW.csv": [
		4827,
		1,
		4827
	],
	"./2024/wiatr_offshore.csv": [
		2939,
		1,
		2939
	],
	"./2024/zuzycie_pradu.csv": [
		4515,
		1,
		4515
	],
	"./2024_clean": [
		6812,
		9,
		6812
	],
	"./2024_clean.ts": [
		6812,
		9,
		6812
	],
	"./2025": [
		6761,
		9
	],
	"./2025.ts": [
		6761,
		9
	],
	"./2025/PV.csv": [
		7245,
		1,
		7245
	],
	"./2025/PV_wsch_zach.csv": [
		2702,
		1,
		2702
	],
	"./2025/Profil_2025_PV_1k.xlsx": [
		5094,
		1,
		5094
	],
	"./2025/Profil_2025_PV_Wszch_Zach_1k.xlsx": [
		620,
		1,
		620
	],
	"./2025/Profil_2025_temperatura_1k.xlsx": [
		1597,
		1,
		1597
	],
	"./2025/Profil_2025_wiatr_offshore_1k.xlsx": [
		7749,
		1,
		7749
	],
	"./2025/Profil_2025_wiatr_onshore_1k.xlsx": [
		6513,
		1,
		6513
	],
	"./2025/Profil_2025_wiatr_onshore_6MW_1k.xlsx": [
		4270,
		1,
		4270
	],
	"./2025/Profil_2025_zapotrzebowanie_na_energie_1k.xlsx": [
		8531,
		1,
		8531
	],
	"./2025/data_xls_tocsv.py": [
		1598,
		1,
		1598
	],
	"./2025/redane.zip": [
		1167,
		1,
		1167
	],
	"./2025/srednia_temp.csv": [
		6104,
		1,
		6104
	],
	"./2025/wiatr_lad.csv": [
		4457,
		1,
		4457
	],
	"./2025/wiatr_lad_6MGW.csv": [
		9924,
		1,
		9924
	],
	"./2025/wiatr_offshore.csv": [
		4951,
		1,
		4951
	],
	"./2025/zuzycie_pradu.csv": [
		8242,
		1,
		8242
	],
	"./cleaner.py": [
		2220,
		1,
		2220
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 8613;
module.exports = webpackAsyncContext;